import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import './style.css';

const Navbar = () => {

    return (
        <navbar className="navbar-container">
            <div className="nav-container">
                <div className='tribe-logo' >
                    <Link to="/">
                        <img src="/tribemails-logo.png" />
                    </Link>
                </div>
                <div className='profile-container' >
                    <img src="/profile.jpg" />
                </div>
            </div>
         </navbar>
    );
};

export { Navbar };
